import { parseArticleList } from '../utils/parseArticleList';
import fetchApiWithAuth from './fetch';

function csvCell(value: string): string {
  if (/[",;\n\r]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

function articlesToTagCsv(articles: string[], tagName: string): string {
  return articles.map((article) => `${csvCell(article)},${csvCell(tagName)}`).join('\n');
}

export type GoodsTag = {
  id: number;
  name: string;
  goods_count?: number;
};

export const getAll = async (): Promise<GoodsTag[]> => {
  const result = await fetchApiWithAuth('/api/goods-tags');
  return (await result.json()) as GoodsTag[];
};

export const create = async (name: string): Promise<GoodsTag> => {
  const result = await fetchApiWithAuth('/api/goods-tags', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
  const data = await result.json();
  if (!result.ok) {
    throw new Error(data?.message || 'Ошибка при создании тега');
  }
  return data as GoodsTag;
};

export const unlinkAll = async (
  id: number
): Promise<{ unlinked: number }> => {
  const result = await fetchApiWithAuth(`/api/goods-tags/${id}/unlink-all`, {
    method: 'POST',
  });
  const data = await result.json();
  if (!result.ok) {
    throw new Error(data?.message || 'Ошибка при отвязке тега');
  }
  return data as { unlinked: number };
};

export const remove = async (
  id: number
): Promise<{ deleted: true; unlinked: number }> => {
  const result = await fetchApiWithAuth(`/api/goods-tags/${id}`, {
    method: 'DELETE',
  });
  const data = await result.json().catch(() => ({}));
  if (!result.ok) {
    throw new Error((data as any)?.message || 'Ошибка при удалении тега');
  }
  return data as { deleted: true; unlinked: number };
};

export type ImportCsvResult = {
  linked: number;
  created_tags: number;
  missing_articles: string[];
  rows: number;
};

const importCsvFile = async (file: File): Promise<ImportCsvResult> => {
  const form = new FormData();
  form.append('file', file);
  const result = await fetchApiWithAuth(
    '/api/goods-tags/import-csv',
    {
      method: 'POST',
      body: form,
    },
    true
  );
  const data = await result.json();
  if (!result.ok) {
    throw new Error(data?.message || 'Ошибка импорта CSV');
  }
  return data as ImportCsvResult;
};

export const importCsv = importCsvFile;

export const importCsvText = async (text: string): Promise<ImportCsvResult> => {
  const content = text.trim();
  if (!content) {
    throw new Error('Вставьте CSV: артикул и теги');
  }
  const file = new File([content], 'goods-tags.csv', { type: 'text/csv' });
  return importCsvFile(file);
};

export const linkTagToArticles = async (
  tagName: string,
  articlesText: string
): Promise<ImportCsvResult> => {
  const articles = parseArticleList(articlesText);
  if (!articles.length) {
    throw new Error('Список артикулов пуст');
  }
  const file = new File(
    [articlesToTagCsv(articles, tagName)],
    'link-tag.csv',
    { type: 'text/csv' }
  );
  return importCsvFile(file);
};
